import { useAuth } from './useAuth'
import { WeekStartsOn } from 'providers/WeekScopeProvider'

/**
 * The start day preferred by the person using the app. For screens that show
 * no single user's dated week — settings, reporting ranges, group templates —
 * and to seed the grids whose start day the signed-in user can then toggle.
 */
export const useSignedInUsersWeekStartsOn = (): WeekStartsOn =>
  useAuth().user?.weekStartsOn ?? 'sunday'
